'use client';

import { StarRatingTooltipContent } from './Content';
import { useTooltipPageActionWithoutSkuViewed } from './hooks';
import type { StarRatingTooltipProps } from './Monetizable';

export function NotMonetizableStarRatingTooltip({
  position = 'bottom',
  maxWidth = 240,
  mobileColor,
  mobileFontVariant,
  segmentActionSection,
}: StarRatingTooltipProps) {
  const handleTooltipClickPageActionWithoutSkuViewed = useTooltipPageActionWithoutSkuViewed();

  return (
    <StarRatingTooltipContent
      position={position}
      maxWidth={maxWidth}
      mobileColor={mobileColor}
      mobileFontVariant={mobileFontVariant}
      segmentActionSection={segmentActionSection}
      handleTooltipClickPageAction={handleTooltipClickPageActionWithoutSkuViewed}
    />
  );
}
